import React, { useCallback, useEffect, useRef, useState } from 'react';
import './index.less';
import { loadSSRData } from '../data';
import { Tea, useHideNavValue, useLocationParams, useUserInfo } from '@utils/index';
import cs from 'classnames';

import { useTranslation } from '@ies/intl-react-plugin';
import { Empty } from '@byted/serial-components-i18n';

import Loading from '@components/loading';

import MobileHeader from '@components/mobile-header';
import ArticleContent from '@components/article-content';
import CommentList from '@components/h5/comment-list';
import Footer from '@components/footer';
import { usePostPage } from '../use-post-page';
import { EventType } from '@typings/api/novel/origin_overseas_base';
import { PostPageQuery } from '../typings';
import InAppHeader from '@components/h5/header';
import { PostType } from '@redux/reducers/post';
import { ImagePreview } from '@arco-design/mobile-react-serial-i18n';
import { EVENTS } from '@constants/event';

const PostH5 = () => {
    const { post, id, commentActions, articleContent } = usePostPage();
    const { serverInited, commentOpen, diggCount, extraImg, collectCount } = post;

    const { params: queryObj } = useLocationParams<PostPageQuery>();
    const hideNav = useHideNavValue();
    const { i18n } = useTranslation();
    const user = useUserInfo();
    const pageRef = useRef<HTMLDivElement>(null);
    const getPageRef = useCallback(() => pageRef.current, []);
    const [openIndex, setOpenIndex] = useState(-1);

    const hasScrollEndOnce = useRef(false);

    useEffect(() => {
        if (id) {
            Tea(EVENTS.ENTER_FIZZO_WRITER_FORUM_ALL, {
                post_id: id,
            });
        }
    }, [id]);

    if (!serverInited) {
        return <Loading className="article-loading" />;
    }

    const showComment = user.isLogin && commentOpen;

    return (
        <div ref={pageRef} id="post" className={cs('post', hideNav && 'hide-nav')}>
            {!hideNav ? <MobileHeader /> : null}
            {hideNav && queryObj.title ? (
                <InAppHeader
                    style={{
                        backgroundColor: '#fff',
                    }}
                    title={decodeURIComponent(queryObj.title)}
                />
            ) : null}
            {articleContent.content ? (
                <>
                    <ArticleContent
                        isMobile
                        data={articleContent}
                        needDir={false}
                        showFollowBtn
                        getScrollContainer={getPageRef}
                        onScrollEnd={() => {
                            if (!hasScrollEndOnce.current) {
                                hasScrollEndOnce.current = true;
                                Tea('read_post', { category_name: post.category_name, postId: id });
                            }
                        }}
                    />
                    {extraImg && extraImg.length > 0 && (
                        <div className="img-container">
                            {extraImg.map((item, index) => (
                                <img
                                    key={item?.data?.web_url}
                                    src={item?.data?.web_url}
                                    onClick={() => setOpenIndex(index)}
                                />
                            ))}
                        </div>
                    )}
                    {/* 图片预览 */}
                    {extraImg && extraImg.length > 0 && (
                        <ImagePreview
                            className="post-image-preview"
                            close={() => setOpenIndex(-1)}
                            openIndex={openIndex}
                            images={extraImg?.map(item => ({ src: item?.data?.web_url || '' }))}
                        />
                    )}
                    {showComment ? (
                        <>
                            <div className="post__separator" />
                            <CommentList
                                initScrollPosition={queryObj.scroll_comment === '1' ? 0 : undefined}
                                eventType={EventType.Post}
                                actions={commentActions}
                                getContainer={getPageRef}
                                itemId={id}
                                diggCount={diggCount}
                                collectCount={collectCount}
                                hasCollect
                            />
                        </>
                    ) : null}
                </>
            ) : (
                <Empty description={i18n.t('page_not_accessible')} />
            )}
            {!hideNav && <Footer />}
            {/* 撑起评论底部 fixed input */}
            {showComment ? (
                <div
                    className={cs('post__shim', {
                        'post__shim--black': showComment && !hideNav,
                    })}
                />
            ) : null}
        </div>
    );
};

PostH5.loadData = loadSSRData;

export default PostH5;
